export const ITEMS_PER_PAGE = 10;

export const INITIAL_ORDER_STATE = {
  uuid_destination_warehouse: '',
  uuid_project: '',
  needed_date: '',
  needed_time: '',
  observations: '',
  materials: [],
};

export const getInitialOrderState = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return {
    ...INITIAL_ORDER_STATE,
    needed_date: now.toISOString().split('T')[0],
    needed_time: `${hours}:${minutes}`,
  };
};

export const ORDER_STATUS_LABELS = {
  pending_authorization: 'Pendiente de autorización',
  received: 'Recibido',
  checking_stock: 'Controlando stock',
  stock_available: 'Stock disponible',
  awaiting_transfer: 'Pendiente de traslado',
  ready_to_consume: 'Listo para consumir',
  consumed: 'Consumido',
  cancelled: 'Cancelado',
  failed: 'Fallido',
};

export const ORDER_STATUS_COLORS = {
  pending_authorization: 'warning',
  received: 'info',
  checking_stock: 'info',
  stock_available: 'success',
  awaiting_transfer: 'warning',
  ready_to_consume: 'primary',
  consumed: 'success',
  cancelled: 'error',
  failed: 'error',
};

export const INITIAL_FILTERS = {
  status: '',
  uuid_destination_warehouse: '',
  uuid_project: '',
  date_from: '',
  date_to: '',
};

export const ORDER_ITEM_STATUS_LABELS = {
  pending: 'Pendiente',
  available: 'Disponible',
  missing: 'Faltante',
  in_transfer: 'En traslado',
  ready: 'Listo',
  consumed: 'Consumido',
  cancelled: 'Cancelado',
};

export const CHECK_STOCK_ORDER_STATUSES = ['received', 'checking_stock'];

export const CANCELLABLE_ORDER_STATUSES = [
  'pending_authorization',
  'received',
  'stock_available',
  'awaiting_transfer',
  'ready_to_consume',
];

export const INTERNAL_ORDER_FILTER_TEXTS = {
  status: 'Estado',
  warehouse: 'Depósito',
  project: 'Proyecto',
  dateFrom: 'Desde',
  dateTo: 'Hasta',
  exactNumber: 'Número',
  createdBy: 'Creado por',
  search: 'Buscar...',
};

/** Textos de la tabla de pedidos técnicos (escritorio y tarjetas en mobile). */
export const INTERNAL_ORDERS_TABLE_TEXTS = {
  number: 'Número',
  neededAt: 'Necesidad',
  warehouse: 'Depósito',
  project: 'Proyecto',
  createdBy: 'Creado por',
  status: 'Estado',
  actions: 'Acciones',
  view: 'Ver detalle',
  noWarehouse: 'Sin depósito',
  noProject: 'Sin proyecto',
  empty: 'No se encontraron pedidos técnicos',
  orderTitle: (number) => `Pedido #${number}`,
};

/** Textos del formulario de alta de pedido técnico. */
export const INTERNAL_ORDER_FORM_TEXTS = {
  warehouse: 'Depósito solicitado',
  searchWarehouse: 'Buscar depósito',
  loadingWarehouses: 'Cargando depósitos...',
  project: 'Proyecto',
  searchProject: 'Buscar por barrio, manzana o casa',
  loadingProjects: 'Cargando proyectos...',
  noProjects: 'No se encontraron proyectos',
  unnamedProject: 'Proyecto sin nombre',
  neededDate: 'Fecha de necesidad',
  neededTime: 'Hora de necesidad',
  observations: 'Observaciones',
};

/** Textos de la sección de materiales del formulario de pedido técnico. */
export const INTERNAL_ORDER_MATERIAL_FORM_TEXTS = {
  title: 'Materiales solicitados',
  groups: 'Grupos de materiales',
  searchGroup: 'Buscar grupo',
  search: 'Buscar material',
  searchPlaceholder: 'Código, código externo o descripción',
  waitTyping: 'Espere un momento sin escribir para buscar',
  minLength: (length) => `Escriba al menos ${length} caracteres para buscar`,
  searching: 'Buscando artículo...',
  searchError: 'Error al buscar el artículo',
  alreadyAdded: 'El artículo ya fue agregado al pedido',
  noResults: 'No se encontró un artículo con ese criterio',
  hint: 'Escriba código, código externo o descripción',
  empty: 'Agregue materiales buscando por código, código externo o descripción',
  summary: (count, units) =>
    `${count} material${count !== 1 ? 'es' : ''} · ${units} unidad${
      units !== 1 ? 'es' : ''
    } en total`,
};

/** Encabezados y textos de la tabla de materiales del detalle del pedido. */
export const INTERNAL_ORDER_DETAIL_TABLE_TEXTS = {
  article: 'Artículo',
  requested: 'Solicitado',
  missing: 'Faltante',
  toConsume: 'A consumir',
  status: 'Estado',
  empty: 'Sin materiales cargados',
};

export const REQUESTED_ARTICLES_TEXTS = {
  column: 'Artículos solicitados',
};

export const INTERNAL_ORDER_MATERIALS_TEXTS = {
  expand: 'Ver materiales',
  collapse: 'Ocultar materiales',
  group: 'Grupo',
  code: 'Código',
  material: 'Material',
  unit: 'Unidad',
  requested: 'Pedido',
  consumed: 'Consumido',
  missing: 'Faltante',
  status: 'Estado',
  originalCost: 'Costo original de materiales',
  noGroup: 'Sin grupo',
  empty: 'El pedido no tiene materiales.',
  loadError: 'No se pudieron cargar los materiales',
  retry: 'Reintentar',
};

export const ORDER_ITEM_STATUS_COLORS = {
  pending: 'default',
  available: 'info',
  missing: 'warning',
  in_transfer: 'info',
  ready: 'success',
  consumed: 'success',
  cancelled: 'error',
};
